import { ArrowLeft, ArrowUpRight, LoaderCircle, LockKeyhole, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { FlowSphereLogo } from "../components/FlowSphereLogo";

const formatError = (detail) => Array.isArray(detail) ? detail.map((item) => item.msg).join(" ") : typeof detail === "string" ? detail : "Please try again";

export default function ResetPassword({ onLogin, navigate }) {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — you're signed in");
      onLogin(data);
      navigate("/");
    } catch (error) { toast.error(formatError(error.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return <main className="login-page">
    <section className="login-visual"><button className="login-brand" data-testid="reset-home-button" onClick={() => navigate("/")}><FlowSphereLogo variant="login"/></button><div><span className="section-kicker">ACCOUNT SECURITY</span><h1>Choose a new<br /><em>password.</em></h1><p>Set a strong password to secure your FlowSphere System workspace and sign back in.</p><div className="login-proof"><ShieldCheck size={18}/><span><strong>Secure one-time link</strong><small>This reset link works only once and expires for your protection.</small></span></div></div></section>
    <section className="login-form-panel">
      <button className="back-link" data-testid="reset-back-button" onClick={() => navigate("/login")}><ArrowLeft size={16}/> Back to login</button>
      <div className="login-form-wrap">
        <LockKeyhole size={28}/><span className="section-kicker">RESET PASSWORD</span>
        <h2 data-testid="reset-heading">Set a new password.</h2>
        {token ? <>
          <p>Enter and confirm your new password below.</p>
          <form data-testid="reset-form" onSubmit={submit}>
            <label>New password<input data-testid="reset-password-input" type="password" value={password} onChange={(event) => setPassword(event.target.value)} minLength={8} required/></label>
            <label>Confirm password<input data-testid="reset-confirm-input" type="password" value={confirm} onChange={(event) => setConfirm(event.target.value)} minLength={8} required/></label>
            <button className="white-button" data-testid="reset-submit-button" disabled={busy}>{busy ? <LoaderCircle className="spin"/> : <>Update password &amp; sign in <ArrowUpRight size={17}/></>}</button>
          </form>
        </> : <>
          <p data-testid="reset-invalid-message">This reset link is missing or invalid. Please request a new one from the login page.</p>
          <button className="white-button" data-testid="reset-request-new-button" style={{ marginTop: 28 }} onClick={() => navigate("/login")}>Go to login <ArrowUpRight size={17}/></button>
        </>}
      </div>
    </section>
  </main>;
}
